import React, { useState } from 'react';
import CloudflareImage from '../cloudflare-image/CloudflareImage';
import LangButton from '../../i18n/LangButton';
import './styles/tabs.scss';
import cx from 'classnames';

const Tabs = (props) => {
  const [currentTabID, setCurrentTabID] = useState(props.tabs[0].tabID);
  const [currentTab, setCurrentTab] = useState(props.tabs[0]);

  const handleCurrentTab = (id, tab) => {
    setCurrentTabID(id);
    setCurrentTab(tab);
  };

  return (
    <div className={cx('tabs-feature__container', props.additionalClass)}>
      <div className="tabs-feature__menu">
        {props.tabs.map((tab) => {
          return (
            <div
              key={tab.tabID}
              role="button"
              tabIndex={0}
              className={`tabs-feature__title ${currentTabID === tab.tabID && 'active'}`}
              onClick={() => handleCurrentTab(tab.tabID, tab)}
              onKeyDown={(event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                  handleCurrentTab(tab.tabID, tab);
                }
              }}
            >
              {tab.tabTitle}
              {currentTabID === tab.tabID && <span className="arrow"></span>}
              {props.hasImage &&
                (currentTabID === tab.tabID && tab.activeIcon ? (
                  <CloudflareImage src={tab.activeIcon} alt="" width="31" height="31" />
                ) : (
                  <CloudflareImage src={tab.inactiveIcon} alt="" width="31" height="31" />
                ))}
            </div>
          );
        })}
      </div>

      {currentTab.tabID === currentTabID && (
        <div className="tabs-feature__description">
          {props.hasCta && (
            <LangButton modifier="btn--primary" to={currentTab.cta} externalLink={true}>
              {currentTab.ctaText}
            </LangButton>
          )}
          <div>
            <h3>{currentTab.tabDescTitle}</h3>
            <p>{currentTab.tabDesc}</p>
            {currentTab.additionalContent && currentTab.additionalContent}
          </div>
          {currentTab.tabImg && (
            <CloudflareImage
              src={currentTab.tabImg.img}
              alt={currentTab.tabImg.alt}
              width={currentTab.tabImg.width}
              height={currentTab.tabImg.height}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default Tabs;
